import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import i18n from 'i18n/i18nConfig';
import { ButtonProp } from './ButtonProp';
import { AiFillEdit, AiOutlineClose, AiOutlineCloseCircle, AiOutlineDelete, AiOutlinePlus, AiOutlineSearch, AiFillFilePdf, AiFillEye, AiFillFileExcel } from "react-icons/ai";
import './button.css'
import { FiPlus, FiSend } from "react-icons/fi";
import { MdEditSquare, MdOutlineCancel } from "react-icons/md";
import { BiCheckCircle, BiSave } from "react-icons/bi";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { Save } from "@mui/icons-material";
import Fab from "@mui/material/Fab";


export const BtnDeleteTable = (prop: ButtonProp) => {
    return (
        <button className="buttonDelete" {...prop} style={prop.style}>
            <AiOutlineDelete className="bell" />
            <span className="tooltip">ลบ</span>
        </button>
    );
};
export const BtnEditTable = (prop: ButtonProp) => {
    return (
        <button className="BtnEditTable" {...prop} style={prop.style}>
            <AiFillEdit className="bell" />
            <span className="tooltip">แก้ไข</span>
        </button>
    );
};
export const BtnAddTable = (prop: ButtonProp) => {
    return (
        <button className="BtnAddTable" {...prop} style={prop.style}>
            <AiOutlinePlus className="bell" />
            <span className="tooltip">เพิ่ม</span>
        </button>
    );
};

export const BtnSearchTable = (prop: ButtonProp) => {
    return (
        <button className="BtnSearchTable" {...prop} style={prop.style}>
            <AiOutlineSearch className="bell" />
            <span className="tooltip">ค้นหา</span>
        </button>
    );
};

export const BtnPDFTable = (prop: ButtonProp) => {
    return (
        <button className="BtnPDFTable" {...prop} style={prop.style}>
            <AiFillFilePdf fontSize={"30px"} className="bell" />
            <span className="tooltip">PDF</span>
        </button>
    );
};

export const BtnExcelTable = (prop: ButtonProp) => {
    return (
        <button className="BtnExcelTable" {...prop} style={prop.style}>
            <AiFillFileExcel fontSize={"30px"} className="bell" />
            <span className="tooltip">Excel</span>
        </button>
    );
};

export const BtnViewTable = (prop: ButtonProp) => {
    return (
        <button className="BtnViewTable" {...prop} style={prop.style}>
            <AiFillEye className="bell" />
            <span className="tooltip">รายละเอียด</span>
        </button>
    );
};


export const BtnAdd = (prop: ButtonProp) => {
    return (
        <button className="BtnAdd" {...prop}>
            <div className="sign"><FiPlus /></div>
            <div className="text">เพิ่ม</div>
        </button>
    );
};

export const BtnSaveIcon = (prop: ButtonProp) => {
    return (
        <button className="BtnSaveIcon" {...prop}>
            <span className="IconContainer">
                <BiSave />
            </span>
            <p className="text">บันทึก</p>
        </button>
    );
};

export const BtnOKIcon = (prop: ButtonProp) => {
    return (
        <button className="BtnOKIcon" {...prop}>
            <span className="IconContainer">
                <BiCheckCircle />
            </span>
            <p className="text">ตกลง</p>
        </button>
    );
};

export const BtnCancelIcon = (prop: ButtonProp) => {
    return (
        <button className="BtnCancelIcon" {...prop}>
            <span className="IconContainer">
                <MdOutlineCancel />
            </span>
            <p className="text">ยกเลิก</p>
        </button>
    );
};

export const BtnPDFIcon = (prop: ButtonProp) => {
    return (
        <button className="BtnPDFIcon" {...prop}>
            <span className="IconContainer">
                <AiFillFilePdf />
            </span>
            <p className="text">PDF</p>
        </button>
    );
};

export const BtnExcelIcon = (prop: ButtonProp) => {
    return (
        <button className="BtnExcelIcon" {...prop}>
            <span className="IconContainer">
                <AiFillFileExcel />
            </span>
            <p className="text">Excel</p>
        </button>
    );
};

export const BtnSubmit = (prop: ButtonProp) => {
    const { title = i18n.t("submit") } = prop;
    return (
        <Tooltip title={title}>
            <Button
                id={prop.id || "BtnSubmit"}
                variant="contained"
                style={{ backgroundColor: "", color: "", zIndex: 1, marginTop: '3px', ...prop.style }}
                onClick={prop.onClick}
                disabled={prop.disabled ? true : false}
                hidden={prop.hidden ? true : false}
                color="success"
                size="small"
                startIcon={prop.startIcon ? prop.startIcon : <FiSend style={{ marginTop: "0px", fontSize: "16px" }} />}
                endIcon={prop.endIcon}>
                {prop.children ? prop.children : title}
            </Button>
        </Tooltip>
    );
};
export const BtnCancel = (prop: ButtonProp) => {
    const { title = i18n.t("cancel") } = prop;
    return (
        <Tooltip title={title}>
            <Button
                id={prop.id || "BtnCancel"}
                color="inherit"
                variant="contained"
                style={{ backgroundColor: "rgb(185 185 185)", color: "white", zIndex: 1, marginTop: '3px', ...prop.style }}
                onClick={prop.onClick}
                disabled={prop.disabled ? true : false}
                hidden={prop.hidden ? true : false}
                size="small"
                startIcon={prop.startIcon ? prop.startIcon : <AiOutlineClose style={{ fontSize: "14px" }} />}
                endIcon={prop.endIcon}>
                {prop.children ? prop.children : title}
            </Button>
        </Tooltip>
    );
};
export const BtnClose = (prop: ButtonProp) => {
    const { title = i18n.t("Close") } = prop;
    return (
        <Tooltip title={title}>
            <Button
                id={prop.id || "BtnClose"}
                color="inherit"
                className="TSButton"
                variant="contained"
                style={{ backgroundColor: "red", color: "#fff", zIndex: 1, marginTop: '3px', ...prop.style }}
                onClick={prop.onClick}
                disabled={prop.disabled ? true : false}
                hidden={prop.hidden ? true : false}
                size="small"
                startIcon={prop.startIcon ? prop.startIcon : <AiOutlineCloseCircle style={{ color: "#fff", fontSize: "16px" }} />}
                endIcon={prop.endIcon}>
                {prop.children ? prop.children : title}
            </Button>
        </Tooltip>
    );
};

export const BtnBack = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "Back",
    Color = "#dcdbdb"
}) => {
    return (
        <Tooltip title={txt}>
            <Button
                startIcon={<ArrowBackIosRoundedIcon />}
                variant="contained"
                color="warning"
                onClick={onClick}
                disabled={isDisabled ? true : false}
                hidden={isHidden ? true : false}
                style={{ backgroundColor: Color, color: "#000000" }}
            >
                {txt}
            </Button>
        </Tooltip>
    );
};

export const BtnSave = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "Save",
    isCircleWithOutText = false,
    sx = {},
    style = {}
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<Save />}
                    variant="contained"
                    color="success"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                    style={{ display: isHidden ? "none" : "", textTransform: "none", ...style }}
                    sx={{ sx }}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="save"
                >
                    <Save />
                </Fab>
            )}
        </Tooltip>
    );
};

export const BtnSearch = ({
    isDisabled = false,
    isHidden = false,
    onClick = () => { },
    txt = "ค้นหา",
    isCircleWithOutText = false,
    sx = {},
    style = {}
}) => {
    return (
        <Tooltip title={txt}>
            {!isCircleWithOutText ? (
                <Button
                    startIcon={<AiOutlineSearch className="bell" />}
                    variant="contained"
                    color="primary"
                    onClick={onClick}
                    disabled={isDisabled ? true : false}
                    hidden={isHidden ? true : false}
                    style={{ display: isHidden ? "none" : "", textTransform: "none", ...style }}
                    sx={{ sx }}
                >
                    {txt}
                </Button>
            ) : (
                <Fab
                    sx={{ width: 40, height: 40 }}
                    color="primary"
                    onClick={onClick}
                    aria-label="save"
                >
                    <Save />
                </Fab>
            )}
        </Tooltip>
    );
};